// extracted by mini-css-extract-plugin
export default {"spinner":"InviteNeighborModal_spinner__bpd9O"};